import React from "react";
import PageInfoAndActionBar from "../../../Layouts/PageInfoAndActionBar";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";

const QueryBlockRenderer = ({ applicationBlockData, handleSaveApplicationBlock, handleCloneApplicationBlock }) => {
  const { currentBlockConfig } = useAppBlocksContext();
  return (
    <div>
      <PageInfoAndActionBar
        pagePath={`Blocks/QueryBlock/${applicationBlockData?.name}`}
        clonePage={handleCloneApplicationBlock}
        savePage={handleSaveApplicationBlock}
        currentConfig={[currentBlockConfig, applicationBlockData]}
        pageName="applicationblock"
      />
      <h1 className={"text_center"}>In Progress</h1>
    </div>
  );
};

export default QueryBlockRenderer;
